import { AnalyticsListener } from "@atlaskit/analytics-next";
import EctlList from "@atlassiansox/bxpkit-ectl-list";
import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import Environment from "../../../common/environment";
import Spinner from "@atlaskit/spinner";
import styled from "styled-components";
import tracking from '../../../utils/tracking';
import { FeatureGatesInitialization } from "@atlassian/feature-gates-react";
import {
  FeatureGateEnvironment,
} from "@atlassian/feature-gate-js-client";
import storage from "../../../utils/storage";


const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UTM_WHITE_LIST = ["utm_medium", "utm_source", "utm_campaign"];

const sendAnalytics = (analytic) => {
  const eventName =
    analytic.payload && analytic.payload.name
      ? analytic.payload.name
      : "ectl-list-component-track-event";

  let eventPayload = analytic.payload;
  if (analytic.context[0]) {
    eventPayload = Object.assign(analytic.context[0], analytic.payload);
  }

  if (eventPayload.name !== undefined) {
    delete eventPayload.name;
  }

  try {
    tracking.trackEvent(eventName, eventPayload);
  } catch (e) {
    console.log(eventName, "AnalyticsListener did not find tracker");
  }
};


const EctlListComponentContainer = ({ contentCopy, ectlListConfig }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [ectlLicenses, setEctlLicenses] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [isv2] = useState(ectlListConfig.enableV2LicensesEndpoint);

  function getEctlLicenses() {
    const v2 = isv2? '/v2': '';
    return fetch(
      `${Environment.getAPIPrivateURL()}/ectl/licenses${v2}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          setIsLoggedIn(true);
          return Promise.resolve(response.json());
        } else {
          if (response.status === 401) {
            setIsLoggedIn(false);
            return Promise.resolve({ entitlements: [] });
          } else {
            setIsLoggedIn(null);
            return Promise.reject(response);
          }
        }
      })
      .catch((error) => {
        setIsLoggedIn(null);
        return Promise.reject(error);
      });
  }

  function fetchAndSetStates() {
    getEctlLicenses()
      .then((res) => {
        setEctlLicenses(res.entitlements);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        return Promise.reject(error);
      });
  }

  const getEnvironment = ()  => {
    switch (Environment.getEnvironment()) {
        case "production":
            return {
                apiKey: "4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f",
                environment: FeatureGateEnvironment.Production
            };
        case "staging":
            return {
                apiKey: "ff9c70b0-ab7e-4abc-be4f-53f9c3fd37d6",
                environment: FeatureGateEnvironment.Staging
            };
        case "dev":
        default:
            return {
                apiKey: "ab9944a4-9eb2-482b-b997-36f41f3a1edf",
                environment: FeatureGateEnvironment.Development
            };
    }
  };

  const atlassianAccountId = (storage.getCookie("__aid_user_id") ?? "").replace(
    /\"/g,
    ""
  );

  if (!atlassianAccountId || atlassianAccountId === '') {
    return false;
  }

  useEffect(() => {
    fetchAndSetStates();
  }, []);
  if (!isLoading) {
    return (
      <FeatureGatesInitialization
          options={{
            apiKey: getEnvironment().apiKey,
            environment: getEnvironment().environment,
            targetApp: "bxp-web-platform_web",
          }}
          identifiers={{ atlassianAccountId }}
          customAttributes={{
            platform: 'magnolia',
            locale: document.documentElement.lang || 'en'
          }}
        >
          <AnalyticsListener onEvent={sendAnalytics}>
            <IntlProvider
              locale={document.documentElement.lang}
              messages={contentCopy}
            >
              <EctlList
                ectlRecords={ectlLicenses}
                contactUsUrl={ectlListConfig.contactUsUrl}
                showJSMLicenses={ectlListConfig.showJSMLicenses}
                activateOneYearCloudTrial={ectlListConfig.activateOneYearCloudTrial}
                jsmLogoPathSrc={ectlListConfig.jsmLogoPathSrc}
                activateTrialBaseUrl={ectlListConfig.activateTrialUrl}
                activateUrlParameterKeys={UTM_WHITE_LIST}
                isLoggedIn={isLoggedIn}
                loginUrl={`${Environment.getIdentityBaseUrl()}/login?continue=${
                  window.location.href
                }`}
              />
            </IntlProvider>
          </AnalyticsListener>
      </FeatureGatesInitialization>
    );
  } else {
    return (
      <Loading>
        <Spinner size={"large"} />
      </Loading>
    );
  }
};

export default EctlListComponentContainer;
